function install(Vue) {
  Vue.prototype.$tl = function TranslateLower(...args) {
    return this.$t(...args).toLowerCase();
  };
}

export default install;
